<template>
  <div>
    <!-- :infinite-scroll-disabled="list.length == 0"  防止无限滚动机制和page初始化的时候同时请求数据 -->
    <el-table
      :data="list"
      border
      size="small"
      style="width: 1131px"
      :infinite-scroll-disabled="list.length == 0"
      v-el-table-infinite-scroll="loadMore"
    >
      <el-table-column prop="createdAt" label="时间" align="center" width="140">
        <template slot-scope="scope">
          {{ $util.ms2datetime(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="template.mailTemplateName"
        label="标题"
        align="center"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.template.mailTemplates[0].title }}
        </template>
      </el-table-column>
      <el-table-column label="标题和正文" align="center" width="100">
        <template slot-scope="scope">
          <el-popover v-model="scope.row.isTitleAndContentEverBeingViewed" placement="right" trigger="hover" width="600">
            <div v-if="scope.row.isTitleAndContentEverBeingViewed">
              <MailTemplate :languageTemplates="scope.row.template.mailTemplates" readonly></MailTemplate>
            </div>
            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="props"
        label="附件"
        align="center"
        width="350"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.propList" :key="index">
            {{ attachments[item.id] }} x {{ item.num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="收件人" align="center" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.isSelectPlayersByConditions">
            <span style="font-weight: bold">分区：</span
            >{{ scope.row.zoneId ? scope.row.zoneId : "全分区" }}
            <br />
            <span style="font-weight: bold">渠道：</span
            >{{ scope.row.channelId ? scope.row.channelId : "全渠道" }}
          </div>
          <div v-else-if="scope.row.uidList.length > 0">
            <span style="font-weight: bold"> uid：</span>
            <span v-if="scope.row.uidList.length == 1">{{
              scope.row.uidList[0]
            }}</span>
            <span v-else>
              <li v-for="(item, index) in scope.row.uidList" :key="index">
                {{ item }}
              </li>
            </span>
          </div>
          <div v-else-if="scope.row.tidList.length > 0">
            <span style="font-weight: bold"> tid：</span>
            <span v-if="scope.row.tidList.length == 1">{{
              scope.row.tidList[0]
            }}</span>
            <span v-else>
              <li v-for="(item, index) in scope.row.tidList" :key="index">
                {{ item }}
              </li>
            </span>
          </div>          
        </template>
      </el-table-column>
      <el-table-column
        label="发送人"
        align="center"
        prop="adminUsername"
        width="100"
      >
      </el-table-column>
      <el-table-column
        label="发送人角色"
        align="center"
        prop="role"
        width="100"
      >
        <template slot-scope="scope">
          <span v-for="(role, index) in roles" :key="index">
            {{ role.value == scope.row.role ? role.label : "" }}</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  
<script>
const axios = require("axios");

import MailTemplate from "@/pages/mail/components/MailTemplate";

export default {
  data() {
    return {
      list: [], // 定时邮件列表
      roles: [],
      form: {
        condition: "",
        value: "",
      },
      attachments: {},
    };
  },

  components: {
    MailTemplate,
  },

  async created() {
    this.attachments = await this.$bizutil.loadAttachments(true);

    this.roles = await this.$bizutil.loadRoles();
    // 拉取邮件模板集合
    await this.loadList(0, 10);
  },

  methods: {
    async loadMore() {
      await this.loadList(this.list.length, 10);
    },
    /**
     * 查询定时邮件集合
     */
    async loadList(skip, limit) {
      if (skip == 0) {
        // 清空表格数据
        this.list = [];
      }

      // 向服务器查询模板集合
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryAdminSendMailHistory`,
          {
            skip: skip,
            limit: limit,
            condition: this.form.condition,
            value: this.form.value,
          },
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let mails = resData.data.list || [];

      for (let mail of mails) {
        let propList = JSON.parse(mail.propList);

        this.list.push({
          id: mail.id,
          zoneId: mail.zoneId,
          channelId: mail.channelId,
          isSelectPlayersByConditions: mail.isSelectPlayersByConditions,
          uidList: mail.uidList,
          tidList: mail.tidList,
          propList: propList,
          createdAt: mail.createdAt,
          adminUsername: mail.adminUsername,
          role: mail.role,
          template: {
            mailTemplateId: mail.mailTemplate.mailTemplateId,
            mailTemplateName: mail.mailTemplate.mailTemplateName,
            mailTemplates: mail.mailTemplate.mailTemplates,
          },
        });
      }
    },
  },
};
</script>